/** Local-first player progress. Server sync comes later; the client is the source of truth offline. */
export interface Progress {
  levelIndex: number; // 0-based index into the pack
  fails: Record<string, number>; // levelId -> consecutive fails (drives the free skip, H4)
  revealed: string[]; // imageIds fully revealed (gallery)
}

const KEY = "mozaik.progress";

function empty(): Progress {
  return { levelIndex: 0, fails: {}, revealed: [] };
}

export function loadProgress(): Progress {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      // Saves from before 2026-10-24 also carry `quiz` (the removed picture-guess mode); it is ignored.
      const { levelIndex, fails, revealed } = { ...empty(), ...(JSON.parse(raw) as Partial<Progress>) };
      return { levelIndex, fails, revealed };
    }
  } catch {
    /* ignore */
  }
  return empty();
}

export function saveProgress(p: Progress): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    /* ignore */
  }
}
